// src/App.js
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LocationPicker from "./Locate"; // Import the new component
import LocateDestinationFilterPicker from "./locateDestinationFilterPicker";
import TripTracker from './TripTrack';
import Home from './Home';
import Director from './director';
import RouteDisplay from './route';
import RouteMyLocation from './routeMyLocation';
import Driversdisplay from './driversdisplay';
import TripTracker2 from './Phone/Track';
import MapPicker from './screens/new/MapPicker';
import RideShareDriverRouteLocationPicker from './RideShareDriverRouteLocationPicker';
import RideShareDriverNewRideRouteView from './RideShareDriverNewRideRouteView';
import RideShareDriverPassengerIn_TransitRouteTrack from './RideShareDriverPassengerIn_TransitRouteTrack';
import RideShareDriverNegotiationRoutePreview from './RideShareDriverNegotiationRoutePreview';
import RideSharePassengerJoinRoutePreview from './RideSharePassengerJoinRoutePreview';
import RideSharePassengerNegotiationRoutePreview from './RideSharePassengerNegotiationRoutePreview';
import RideSharePassengerInTransitRouteTrack from './RideSharePassengerInTransitRouteTrack';
import RideShareDriverInTransitRouteTrack from './RideShareDriverInTransitRouteTrack';
import RideSharePassengerTripCardRoutePreview from './RideSharePassengerTripCardRoutePreview';
import CarHire from './Phone/CarHire';
import ConstructionEquipment from './Phone/ConstructionEquipment';
import OnlineShopping from './Phone/OnlineShopping';
import MoreFeatures from './Phone/MoreFeatures';
import RideShareTripComplete from './Phone/RideShareTripComplete';
import PrivateTripComplete from './Phone/PrivateTripComplete';
import PrivateDriverEndTrip from './Phone/PrivateDriverEndTrip';


const App = () => {
  return (
    <Router>
      <Routes>
      <Route path="/" element={<Home/>} />

        <Route path="/route" element={<RouteDisplay/>} />
        <Route path="/routeMyLocation" element={<RouteMyLocation/>} />
        <Route path="/locate" element={<LocationPicker />} />
        <Route path="/driverfilterdestination" element={<LocateDestinationFilterPicker />} />
        <Route path="/Track/:tripId" element={<TripTracker />} />
        <Route path="/Track2/:tripId" element={<TripTracker2 />} />
        <Route path="/Director/:tripId" element={<Director />} />
        <Route path="/Director" element={<Director />} />
        <Route path ="/d" element = {<Driversdisplay/>}/>
        <Route path ="/picker" element = {<MapPicker/>}/>
        <Route path ="/RideShareDriverRouteLocationPicker" element = {<RideShareDriverRouteLocationPicker />}/>
        <Route path ="/RideShareDriverNewRideRouteView" element = {<RideShareDriverNewRideRouteView />}/>
        <Route path ="/RideShareDriverPassengerIn_TransitRouteTrack" element = {<RideShareDriverPassengerIn_TransitRouteTrack />}/>
        <Route path ="/RideShareDriverNegotiationRoutePreview" element = {<RideShareDriverNegotiationRoutePreview />}/>
        <Route path ="/RideSharePassengerJoinRoutePreview" element = {<RideSharePassengerJoinRoutePreview />}/>
        <Route path ="/RideSharePassengerNegotiationRoutePreview" element = {<RideSharePassengerNegotiationRoutePreview />}/>
        <Route path ="/RideSharePassengerInTransitRouteTrack" element = {<RideSharePassengerInTransitRouteTrack />}/>
        <Route path ="/RideShareDriverInTransitRouteTrack" element = {<RideShareDriverInTransitRouteTrack />}/>
        <Route path ="/RideSharePassengerTripCardRoutePreview" element = {<RideSharePassengerTripCardRoutePreview />}/>
        <Route path="/car-hire" element={<CarHire />} />
        <Route path="/construction-equipment" element={<ConstructionEquipment />} />
        <Route path="/online-shopping" element={<OnlineShopping />} />
        <Route path="/more-features" element={<MoreFeatures />} />
        <Route path="/rideshare-trip-complete" element={<RideShareTripComplete />} />
        <Route path="/private-trip-complete" element={<PrivateTripComplete />} />
        <Route path="/private-driver-end-trip" element={<PrivateDriverEndTrip />} />


      </Routes>
    </Router>
  );
};

export default App;